var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs"},[_c('base-svg',{staticClass:"absolute top-0 left-0 w-6 h-6",class:{
            'fill-primary-blue fill-secondary-blue-lighter': _vm._.isNull(_vm.entry.persona)
        },attrs:{"name":"icon-add-circle"}}),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.entry))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }